import {useEffect, useRef, useState, memo, useMemo} from 'react';
import moment from 'moment';

import Day from "./Day";
import Loading from "../../../components/Loading";

import ukMoment from '../../../../utils/ukTime';
import Data from '../../../../repository';

import styles from '../../../../styles/Calendar.module.scss';

function Sessions({ studio, start, end, loading, setLoading, selectedSessions, toggleSession, user }) {
	const [sessions, setSessions] = useState([]);

	const prevDeps = useRef({ studio: null, start: null, end: null });

	useEffect(async () => {
		const hasDepsChanged =
			prevDeps.current.studio !== studio ||
			prevDeps.current.start !== start ||
			prevDeps.current.end !== end;

		if(hasDepsChanged) {
			await setSessions(await fetchSessions(studio, start, end));
			await setLoading(false);
		}
	}, [studio, start, end]);

	const fetchSessions = async (studio, start, end) => {
		const result = await Data.fetchSessions(studio, start, end);
		return result.data;
	}

	const dayKeys = useMemo(() => {
		if(!start || !end) return [];
		const startDate = new Date(start);
		const endDate = new Date(end);
		const numberOfDays = Math.ceil((endDate - startDate) / 86400000);
		const keys = [];
		for(let i = 0; i < numberOfDays; i++){
			const day = new Date(startDate);
			day.setUTCDate(day.getUTCDate() + i);
			keys.push(moment.utc(day).format('YYYY-MM-DD'));
		}
		return keys;
	}, [start, end]);

	const rowTimes = useMemo(() => {
		const times = new Set();
		sessions.forEach((session) => {
			times.add(ukMoment(session.start).format('HH:mm'));
		});

		return Array.from(times).sort((a, b) => {
			const [aHour, aMinute] = a.split(':').map(Number);
			const [bHour, bMinute] = b.split(':').map(Number);
			return (aHour * 60 + aMinute) - (bHour * 60 + bMinute);
		});
	}, [sessions]);

	if(loading) return <Loading button={false} />

	return (
		<div className={styles.sessions}>
			{dayKeys.map(day => (
				<Day
					key={day}
					day={day}
					sessions={sessions}
					rowTimes={rowTimes}
					selectedSessions={selectedSessions}
					toggleSession={toggleSession}
					user={user}
				/>
			))}
		</div>
	)
}

export default memo(Sessions);
